import { render, staticRenderFns } from "./TranslationDisplay.vue?vue&type=template&id=5cbb8860&scoped=true&"
import script from "./TranslationDisplay.vue?vue&type=script&lang=js&"
export * from "./TranslationDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbb8860",
  null
  
)

export default component.exports